import { always, cond, equals, T } from 'ramda';
import { CLASSNAME_DOCUMENT_LANDSCAPE, CLASSNAME_DOCUMENT_PORTAIT } from '../_CONST';

export const getClassNameOrientation = (orientation) => cond([
  [equals('portrait'), always(CLASSNAME_DOCUMENT_PORTAIT)],
  [equals('landscape'), always(CLASSNAME_DOCUMENT_LANDSCAPE)],
  [T, always(CLASSNAME_DOCUMENT_PORTAIT)]
])(orientation);
